import React from 'react';
import PropTypes from 'prop-types';
import moment from "moment";
import FlatButton from 'material-ui/FlatButton';
import Dialog from 'material-ui/Dialog';
import {MdTextField} from 'core/components/fields/fields';
import mdEntityService from "core/metamodel/mdEntityService";
import commonService from 'core/common/service/commonService';
import {ErrorComp} from 'core/components/errorComp/errorComp';
import {observable, action, ObservableMap} from "mobx";
import MdEntity, {LovItem} from "core/metamodel/mdEntity";
import {observer} from "mobx-react";
import uiService from "core/common/service/uiService";
import {DialogAncestor, DialogProps} from "core/common/page/dialogAncestor";
import {
  ACTIVITYLOCATION, ACTIVITYTYPE, TaskDto,
  TASKTYPE, EntityStatus, PartyActivity, ccEmailAddress
} from "core/event/eventDomain";
import EmailBodyEditor from "core/components/editors/emailBodyEditor";
import {EditorState} from 'draft-js';
import {stateToHTML} from 'draft-js-export-html';
import eventService from "core/event/eventService";
import StyledDatePicker from "core/components/fields/styledDatePicker";
import {lovLabel} from "core/form/formUtils";
import {fieldStyles} from "core/form/createForm";
import {OverlayTrigger, Tooltip} from "react-bootstrap";
import Chip from "material-ui/Chip";
import styled from "styled-components";
import StyledSelect from "core/components/fields/styledSelect";
import {optionsSearch} from "core/common/service/commonDataService";
import {PARTYROLE} from "party/partyDomain";
import securityService from "core/security/securityService";
import {addTenantToQuery} from "core/common/utils/utils";
import {GridParams} from "core/grid/domain/grid";
import {grey400} from "material-ui/styles/colors";


interface TaskDialogProps extends DialogProps {
  location?: ACTIVITYLOCATION;
  taskType?: TASKTYPE;
}


const FlexDiv = styled.div`
  display: flex;
`;


@observer
export default class TaskDialog extends DialogAncestor<TaskDialogProps, undefined, any> {


  @observable private editorState: EditorState;
  @observable private taskDto: TaskDto;



  @action open(resolve, reject, gridParams: GridParams) {
    let {entities, location, taskType} = this.props;

    uiService.showToolbarActionFlag();

    console.log('TaskDialog: Opening dialog for ', gridParams);

    this.resolve = resolve;
    this.reject = reject;
    this.$errors = null;

    this.editorState = EditorState.createEmpty();



    Promise.all([mdEntityService.fetchEntities([{entity: "ACTIVITYTYPE", lov: true}, {entity: "TASKTYPE", lov: true}]), eventService.prepareTaskActivity(location, gridParams)])
      .then(action("open-promise-actionCb", ([entities, statuses]: [ObservableMap<MdEntity>, EntityStatus[]]) => {

        this.taskDto = new TaskDto({
          statuses,
          taskType,
          type: entities.get("ACTIVITYTYPE").getLovItem(ACTIVITYTYPE.EMAIL),
        });

        this.dialogOpen = true;
        uiService.hideToolbarActionFlag();
      }))
      .catch(error => {
        this.reject(error);
      });

  }



  @action ok = () => {
    console.log('TaskDialog OK');

    commonService.loading(true);

    this.taskDto.bodyTemplate = stateToHTML(this.editorState.getCurrentContent());

    eventService.createTask(this.taskDto)
      .then(action("createTask-action", () => {
        commonService.loading(false);
        this.dialogOpen = false;
        this.taskDto = null;
        this.resolve(null);
      }), error => {
        this.$errors = error.getMessages();
      });
  };


  @action cancel = (evt) => {
    console.log('TaskDialog#cancel evt = %O', evt);
    this.taskDto = null;
    this.dialogOpen = false;
    this.reject(null);
  };


  @action onChangeSubject = (evt) => {
    this.taskDto.subjectTemplate = evt.target.value;
  };

  @action onChangeScheduledDate = (value) => {
    this.taskDto.scheduledDate = value;
    if (value && moment().startOf('day').isAfter(value)) {
      this.taskDto.$scheduledDateError = "Date must be current day or bigger";
    } else {
      this.taskDto.$scheduledDateError = undefined;
    }
  };

  @action onChangeBody = (editorState) => {
    this.editorState = editorState;
  };





  componentWillUnmount() {
    this.taskDto = null;
  }



  render() {

    let {entities, taskType} = this.props;

    if (!(this.taskDto && this.dialogOpen)) return null;

    console.debug("rendering TaskDialog ", this.taskDto);


    let allHasEmail = (this.taskDto.statuses.length === this.taskDto.statuses.filter(es => es.partyActivity.persons.filter(pLov => pLov._emailAddresses && pLov._emailAddresses.length).length).length);

    return (
      <Dialog
        actions={[<FlatButton key="0" label="Cancel" tabIndex={0} primary onClick={this.cancel}/>,
          <FlatButton key="1" label="Ok" disabled={!allHasEmail || !this.taskDto.scheduledDate || !!this.taskDto.$scheduledDateError} secondary onClick={this.ok}/>
        ]}
        modal={true}
        title={entities.get("TASKTYPE").getLovItemLabel(taskType)}
        open={this.dialogOpen}
        contentStyle={{width: '80%', maxWidth: 800}}
        bodyStyle={{overflowY: 'auto'}}
      >


        <ErrorComp messages={this.$errors}/>

        <div style={{display: 'flex', marginBottom: 15}}>
          <div style={{paddingTop: 25, marginRight: 20}}>Email will be send to these Sales reps on</div>
          <StyledDatePicker  value={this.taskDto.scheduledDate} onChange={this.onChangeScheduledDate}
                             hintText="Scheduled Date" errorText={this.taskDto.$scheduledDateError}  {...fieldStyles.small.textField} />
        </div>

        <div style={{marginBottom: 10}}>
          {this.taskDto.statuses.map((es,i) => (<TaskPartyActivityComp entityStatus={es} index={i} key={i} />))}
        </div>


        <MdTextField value={this.taskDto.subjectTemplate} onChange={this.onChangeSubject} fullWidth style={{marginTop: 10}}
                     hintText="Subject"/>

        <EmailBodyEditor editorState={this.editorState} onChange={this.onChangeBody} style={{height: 400}}/>

      </Dialog>
    );
  }

}




interface TaskPartyActivityCompProps {
  entityStatus: EntityStatus;
  index: number;
}


@observer
class TaskPartyActivityComp extends React.Component<TaskPartyActivityCompProps, undefined> {

  @observable private newPerson: LovItem;
  @observable private ccText: string;

  componentWillMount() {
    let {entityStatus} = this.props;
    let strings = ccEmailAddress(entityStatus.partyActivity.emailRecipients);
    this.ccText = strings.join(", ");
    entityStatus.emails = strings;
  }

  @action addMe = (evt) => {
    console.log('TaskDialog#addMe evt = %O', evt);
    let {entityStatus} = this.props;
    let mePartyLov = securityService.currentUser.getMePartyLov();

    let index = entityStatus.partyActivity.persons.findIndex(pLov => pLov.value === mePartyLov.value);
    if (index === -1) {
      mePartyLov["emailAddresses"] = [securityService.currentUser.email];
      entityStatus.partyActivity.persons.push(mePartyLov);
    }

  };

  @action onChangeAddPerson = (valueLov) => {
    console.log('TaskDialog#addPerson value = %O', valueLov);
    let {entityStatus} = this.props;
    if (valueLov) {
      let index = entityStatus.partyActivity.persons.findIndex(pLov => pLov.value === valueLov.value);
      if (index === -1) {
        entityStatus.partyActivity.persons.push(valueLov);
      }
    }
  };

  @action onChangeCc = (evt) => {
    let {entityStatus} = this.props;
    this.ccText = evt.target.value;
    entityStatus.emails = (this.ccText) ? this.ccText.split(',').filter(s => s).map(s => s.trim()) : [];
  };



  render() {
    let {entityStatus} = this.props;

    let isValid = entityStatus.partyActivity.persons.filter(pLov => pLov._emailAddresses && pLov._emailAddresses.length).length!!;

    return (
      <div style={{position: 'relative'}}>

        <div style={{
          position: 'absolute',
          right: 5,
          top: 0,
          fontSize: 12,
          color: grey400
        }}>{lovLabel(entityStatus.partyActivity.customer)}</div>

        <FlexDiv style={{display: 'flex', flexWrap: 'wrap'}}>
          {entityStatus.partyActivity.persons.map((pLov, index) => <PersonChip partyActivity={entityStatus.partyActivity} index={index} pLov={pLov} key={pLov.value}/>)}
        </FlexDiv>

        <div className="row" style={{marginTop:10}}>
          <div className="fx col-xs-6" style={{paddingLeft:5}}>
            <StyledSelect  {...fieldStyles.small.styledSelect} name="addPerson" floatingLabelText="Add Person" value={this.newPerson} async={true}
                           fullWidth={true} onChange={this.onChangeAddPerson} clearable={false}
                           loadOptions={optionsSearch.bind(this, 'Party', {role: [PARTYROLE.CONTACT_ROLE, PARTYROLE.SALESREP_ROLE], emailAddresses: true})} />
          </div>
          <div className="col-xs-2" style={{paddingRight:25, paddingTop: 10}}>
            <FlatButton label="Add Me" secondary onClick={this.addMe}/>
          </div>
          <div className="fx col-xs-4">
            <MdTextField {...fieldStyles.small.textField} value={this.ccText} onChange={this.onChangeCc} fullWidth floatingLabelText="CC Emails (delimited by comma)"/>
          </div>
        </div>

        {(!isValid) ? <div className="color-red-500">No Person with email address selected</div> : null}


      </div>
    );
  }
}



interface PersonChipProps {
  pLov: LovItem & {_emailAddresses?: string[]} ;
  partyActivity: PartyActivity;
  index: number;
}

const __chipStyle = {
  margin: "4px 8px 4px 0"
};

@observer
class PersonChip extends React.Component<PersonChipProps, undefined> {

  static contextTypes = {
    router: PropTypes.func.isRequired
  };

  @action handleRequestDelete = (evt) => {
    let {partyActivity, index} = this.props;
    console.log("deleting: " + index);
    partyActivity.persons.splice(index, 1);
  };

  private routeName = "partyDetail";

  onClick = (event) => {
    event.preventDefault();
    let {pLov} = this.props;
    this.context.router.transitionTo(this.routeName, {id: pLov.value});
  };

  render() {
    let {pLov} = this.props;
    let emails = pLov._emailAddresses;
    return (
      <OverlayTrigger placement="top" delayShow={500} overlay={<Tooltip id={pLov.value + "_personTooltip"}>{(emails && emails.length) ? emails.join(", ") : ""}</Tooltip>}>

          <Chip
            onRequestDelete={this.handleRequestDelete}
            style={__chipStyle}>
            <a
               href={this.context.router.makeHref(this.routeName, {id: pLov.value}, addTenantToQuery())}
               onClick={this.onClick}>
              {lovLabel(pLov)}
            </a>
          </Chip>


      </OverlayTrigger>
    );
  }
}



// WEBPACK FOOTER //
// ./src/core/event/component/taskDialog.tsx